import PlayAudioButton, {
  type PlayAudioButtonHandle,
} from "app/ui/PlayAudioButton";
import cn from "app/utils/classnames";
import {
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import { type PreloadedAudio } from "app/utils/usePreloadedAudio";

export interface WordCluesHandle {
  // Force the first audio button to play [audioUrl]
  forcePlay: (audio: PreloadedAudio) => void;
  // Force all audio buttons to stop playing
  forceStop: () => void;
}

interface WordCluesProps {
  className?: string;
  wordAudioUrl?: string;
  definitionAudioUrl?: string;
  etymologyAudioUrl?: string;
}

const WordClues = forwardRef<WordCluesHandle, WordCluesProps>(
  (props: WordCluesProps, ref) => {
    const wordButtonRef = useRef<PlayAudioButtonHandle>(null);
    const defButtonRef = useRef<PlayAudioButtonHandle>(null);
    const etyButtonRef = useRef<PlayAudioButtonHandle>(null);

    useImperativeHandle(ref, () => ({
      forcePlay(audio) {
        wordButtonRef.current?.forcePlay(audio);
      },
      forceStop() {
        wordButtonRef.current?.forceStop();
        defButtonRef.current?.forceStop();
        etyButtonRef.current?.forceStop();
      },
    }));

    function handleAudioButtonClick(
      ref: React.RefObject<PlayAudioButtonHandle | null>,
    ) {
      if (ref !== wordButtonRef) {
        wordButtonRef.current?.forceStop();
      }
      if (ref !== defButtonRef) {
        defButtonRef.current?.forceStop();
      }
      if (ref !== etyButtonRef) {
        etyButtonRef.current?.forceStop();
      }
    }

    return (
      <div
        className={cn(
          "w-full flex justify-center items-center gap-4",
          props.className,
        )}
      >
        {props.wordAudioUrl && (
          <PlayAudioButton
            ref={wordButtonRef}
            audioUrl={props.wordAudioUrl}
            onClick={() => handleAudioButtonClick(wordButtonRef)}
            // className="min-w-26"
          >
            Hear Word
          </PlayAudioButton>
        )}
        {props.definitionAudioUrl && (
          <PlayAudioButton
            ref={defButtonRef}
            audioUrl={props.definitionAudioUrl}
            onClick={() => handleAudioButtonClick(defButtonRef)}
            // className="min-w-26"
          >
            Hear Meaning
          </PlayAudioButton>
        )}
        {props.etymologyAudioUrl && (
          <PlayAudioButton
            ref={etyButtonRef}
            audioUrl={props.etymologyAudioUrl}
            onClick={() => handleAudioButtonClick(etyButtonRef)}
            // className="min-w-26"
          >
            Hear Origin
          </PlayAudioButton>
        )}
      </div>
    );
  },
);

export default WordClues;
